import React from 'react';
import KetReadingPart2 from './KetReadingPart2';

// KET Reading & Writing Part 3a (short conversations) uses the exact same
// 3-option MCQ data shape and rendering as Part 2 (just without the {{gap}}
// token, which the shared renderer only replaces when present).
const KetReadingPart3a = (props) => <KetReadingPart2 {...props} />;

export default KetReadingPart3a;
